import coin from "../assets/complere.png";
import coin2 from "../assets/base.png";
import coin3 from "../assets/eth.png";

export const list = [
    {
        name: "Ethereum",
        img: coin3,
        status: true,
        count: 0,
        symbol: "ETH",
        address: "0x0000000000000000000000000000000000000000",
        decimals: 18,
    },
    // {
    //     name: "Complere",
    //     img: coin,
    //     status: true,
    //     count: 0,
    //     type: "ABC",
    //     address: "0xE31901bCa1B09c8Cc0d049B65a331af324B32F7D",
    //     decimalPlace: 18,
    // },
    {
        name: "USDC",
        // img: coin,
        img: "https://raw.githubusercontent.com/dhavalmp194/crypto-icons/refs/heads/main/cryptocurrency-icons-master/128/icon/usdc.png",
        status: true,
        count: 0,
        symbol: "USDC",
        type: "USDC",
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        decimals: 6,
        decimalPlace: 6,
    },
    {
        name: "USDT",
        img: "https://raw.githubusercontent.com/dhavalmp194/crypto-icons/refs/heads/main/cryptocurrency-icons-master/128/icon/usdt.png",
        status: true,
        count: 0,
        symbol: "USDT",
        type: "USDT",
        address: "0xfde4C96c8593536E31F229EA8f37b2ADa2699bb2",
        decimals: 6,
        decimalPlace: 6,
    },
    {
        name: "CashVault",
        img: null,
        emoji: "🔐",
        status: true,
        count: 0,
        symbol: "CVLT",
        type: "CVLT",
        address: "0x1fDefF2Da6082FcD627D58abf7772cd885Fd34C0",
        decimals: 18,
        decimalPlace: 18,
    },
];
